import React from "react";
import { Row, Label, Button, Col } from "reactstrap";
import { toast } from "react-toastify";

import RegistryService from "../../services/registry";
import { useAppContext } from "../../AppProvider";
import { callErrorToast } from "../../utilities";

const registryService = new RegistryService();

const Delete = ({ companyId, modalToogle, refreshTable }) => {
  const { dictionary } = useAppContext();

  const deleteCompany = () => {
    registryService
      .deleteCompanies(companyId)
      .then((response) => {
        refreshTable();
        modalToogle();
        //Probabilmente bisogna fare una funzione nel padre (notify) con il componente Toast nel padre
        toast.success(dictionary.messages.item_deleted_successfully, {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label>{dictionary.messages.ask_to_delete}</label>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-link"
          onClick={() => {
            refreshTable();
            modalToogle();
          }}
        >
          {dictionary.actions.cancel}
        </button>
        <Button className="btn btn-danger ms-3" onClick={deleteCompany}>
          {dictionary.actions.delete}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default Delete;
